const initialState: any = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'set_aside_info':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
